import { createApp } from 'vue'
import 'bootstrap/dist/js/bootstrap.bundle'
import App from './App.vue'
import router from './router';
import store from './store'
import '@/assets/scss/app.scss'
import VueFeather from 'vue-feather';
import { createI18n } from 'vue-i18n'
import en from './locales/en.json';
import es from './locales/es.json';
import { defaultLocale, localeOptions } from './constants/config';
import Breadcrumbs from './components/bread_crumbs';
import VueSelect from "vue3-select-component";
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

// const messages = { en: en, es: es, pt: pt, fr: fr};
 const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
 const i18n = createI18n({
  locale: locale,
  fallbackLocale: 'es',
  messages: {
    en: en,
    es: es,
    English: en,
    Español: es
  }
});

createApp(App).use(Toast).use(i18n).use(router).use(store).component(VueFeather.name, VueFeather).component('Breadcrumbs', Breadcrumbs).component('VueSelect', VueSelect).component('EasyDataTable', Vue3EasyDataTable).component('VueDatePicker', VueDatePicker).mount('#app')
